export class NestedError extends Error {
	constructor(message: string, cause: any) {
		super(message)
		this.cause = cause
	}
}
